/**
 * A stable id for this tab's session. Sent on every API request (X-Keep-Client)
 * and on the live-sync WebSocket (?cid=) so the server can skip echoing a
 * change back to the tab that made it — otherwise the saving tab refetches its
 * whole notes list in reaction to its own keystroke-save.
 */
export const CLIENT_ID =
  typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : Math.random().toString(36).slice(2);
